import {Button, Grid} from "@mui/material";
import {ContentPasteSearchOutlined} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import PerformanceAnalysisPage from "../PerformanceAnalysis/PerformanceAnalysisPage";
import {GenerationEnergy} from "../GenerationEnergyChart/GenerationEnergy";
import YeldChartComparison from "../YieldChartComparison/YeldChartComparison";
import PRComparison from "../PRComparison/PRComparison";
import { useAppSelector } from "../../../Config/Hooks";
import { hasPermission } from "../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../Config/Constants";
import { SystemRoutes } from "../../../Utils/RouteUtils";
import { ASectionTitle } from "@atiautomacao/ati-ui-library";

export default function DashboardOverviewChartsPage(){

    const navigate = useNavigate();
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToViewDailyReport = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD_DAILY_REPORT
    ]);

    return(
            <Grid container spacing={'24px'} paddingLeft={'24px'} paddingRight={'24px'} paddingBottom={'24px'}>
                <Grid item xs={12}>
                    <ASectionTitle
                        styleContainer={{ padding: '0 24px 24px 0px' }}
                        titleLabel="Visão Diária"
                        contentChildren={
                            isAuthorizedToViewDailyReport ? (
                                <Button
                                    variant="text"
                                    color="primary"
                                    size="small"
                                    startIcon={<ContentPasteSearchOutlined />}
                                    sx={{
                                        textTransform: 'uppercase',
                                        '&:hover': {
                                            backgroundColor: 'transparent'
                                        },
                                        display: 'flex',
                                        justifyContent: 'right',
                                    }}
                                    onClick={() => navigate(SystemRoutes.DASHBOARD_DAILY_REPORT)}
                                >
                                    ver diário de operação
                                </Button>
                            ) : undefined
                        }
                    />
                </Grid>
                <Grid item xs={12} style={{padding: '0 24px'}}>
                    <PerformanceAnalysisPage />
                </Grid>
                 <Grid item xs={12}>
                    <ASectionTitle
                       styleContainer={{ padding: '32px 24px 24px 0px' }}
                       titleLabel="Indicadores de Desempenho"/>
                </Grid>
                <Grid item xs={12} style={{padding: 24, paddingTop:0}}>
                    <GenerationEnergy/>
                </Grid>
                <Grid item xs={12} lg={12} xl={5} style={{padding: 24}}>
                    <PRComparison />
                </Grid>
                <Grid item xs={12} lg={12} xl={7} style={{padding: 24}}>
                    <YeldChartComparison />
                </Grid>
            </Grid>
    );
}
